// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.5.2 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/graph/vertex_metadata.proto (package mochabugapis.adapt.graph, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import type { Exchange, ExchangeJson } from "./exchange_pb";
import { file_mochabugapis_adapt_graph_exchange } from "./exchange_pb";
import type { Receiver, ReceiverJson } from "./receiver_pb";
import { file_mochabugapis_adapt_graph_receiver } from "./receiver_pb";
import type { Transmitter, TransmitterJson } from "./transmitter_pb";
import { file_mochabugapis_adapt_graph_transmitter } from "./transmitter_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/graph/vertex_metadata.proto.
 */
export const file_mochabugapis_adapt_graph_vertex_metadata: GenFile = /*@__PURE__*/
  fileDesc("Ci5tb2NoYWJ1Z2FwaXMvYWRhcHQvZ3JhcGgvdmVydGV4X21ldGFkYXRhLnByb3RvEhhtb2NoYWJ1Z2FwaXMuYWRhcHQuZ3JhcGgihwUKDlZlcnRleE1ldGFkYXRhEhAKCGNvbXBsZXRlGAEgASgIErABCglyZWNlaXZlcnMYAiADKAsyIi5tb2NoYWJ1Z2FwaXMuYWRhcHQuZ3JhcGguUmVjZWl2ZXJCebpIdroBbAoWcmVjZWl2ZXJzX3VuaXF1ZV9uYW1lcxImRWFjaCByZWNlaXZlciBtdXN0IGhhdmUgYSB1bmlxdWUgbmFtZS4aKnRoaXMubWFwKHJlY2VpdmVyLCByZWNlaXZlci5uYW1lKS51bmlxdWUoKZIBBAgBEDISwgEKDHRyYW5zbWl0dGVycxgDIAMoCzIlLm1vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaC5UcmFuc21pdHRlckKEAbpIgAG6AXgKGXRyYW5zbWl0dGVyc191bmlxdWVfbmFtZXMSKUVhY2ggdHJhbnNtaXR0ZXIgbXVzdCBoYXZlIGEgdW5pcXVlIG5hbWUuGjB0aGlzLm1hcCh0cmFuc21pdHRlciwgdHJhbnNtaXR0ZXIubmFtZSkudW5pcXVlKCmSAQIQMhKuAQoJZXhjaGFuZ2VzGAQgAygLMiIubW9jaGFidWdhcGlzLmFkYXB0LmdyYXBoLkV4Y2hhbmdlQne6SHS6AWwKFmV4Y2hhbmdlc191bmlxdWVfbmFtZXMSJkVhY2ggZXhjaGFuZ2UgbXVzdCBoYXZlIGEgdW5pcXVlIG5hbWUuGip0aGlzLm1hcChleGNoYW5nZSwgZXhjaGFuZ2UubmFtZSkudW5pcXVlKCmSAQIQChIoCg1jcm9uX3NjaGVkdWxlGAYgASgJQgy6SAnYAQJyBBABGGRIAIgBAUIQCg5fY3Jvbl9zY2hlZHVsZWIGcHJvdG8z", [file_buf_validate_validate, file_mochabugapis_adapt_graph_exchange, file_mochabugapis_adapt_graph_receiver, file_mochabugapis_adapt_graph_transmitter]);

/**
 * VertexMetadata represents the configuration for a vertex, detailing its inputs,
 * outputs, and processes (such as procedures and streams).
 *
 * @generated from message mochabugapis.adapt.graph.VertexMetadata
 */
export type VertexMetadata = Message<"mochabugapis.adapt.graph.VertexMetadata"> & {
  /**
   * Indicates if the vertex configuration is complete. Defaults to 'false'.
   *
   * @generated from field: bool complete = 1;
   */
  complete: boolean;

  /**
   * Input points for the vertex. Must contain between 1 and 50 receivers,
   * each with a unique name.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.Receiver receivers = 2;
   */
  receivers: Receiver[];

  /**
   * Output points for the vertex. Can contain up to 50 transmitters,
   * each with a unique name.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.Transmitter transmitters = 3;
   */
  transmitters: Transmitter[];

  /**
   * Processes initiated by transmitters and responded to by receivers.
   * Limited to 10 unique procedures.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.Exchange exchanges = 4;
   */
  exchanges: Exchange[];

  /**
   * A unix cron expression to determine when the task should run.
   *
   * @generated from field: optional string cron_schedule = 6;
   */
  cronSchedule?: string;
};

/**
 * VertexMetadata represents the configuration for a vertex, detailing its inputs,
 * outputs, and processes (such as procedures and streams).
 *
 * @generated from message mochabugapis.adapt.graph.VertexMetadata
 */
export type VertexMetadataJson = {
  /**
   * Indicates if the vertex configuration is complete. Defaults to 'false'.
   *
   * @generated from field: bool complete = 1;
   */
  complete?: boolean;

  /**
   * Input points for the vertex. Must contain between 1 and 50 receivers,
   * each with a unique name.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.Receiver receivers = 2;
   */
  receivers?: ReceiverJson[];

  /**
   * Output points for the vertex. Can contain up to 50 transmitters,
   * each with a unique name.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.Transmitter transmitters = 3;
   */
  transmitters?: TransmitterJson[];

  /**
   * Processes initiated by transmitters and responded to by receivers.
   * Limited to 10 unique procedures.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.Exchange exchanges = 4;
   */
  exchanges?: ExchangeJson[];

  /**
   * A unix cron expression to determine when the task should run.
   *
   * @generated from field: optional string cron_schedule = 6;
   */
  cronSchedule?: string;
};

/**
 * Describes the message mochabugapis.adapt.graph.VertexMetadata.
 * Use `create(VertexMetadataSchema)` to create a new message.
 */
export const VertexMetadataSchema: GenMessage<VertexMetadata, {jsonType: VertexMetadataJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_graph_vertex_metadata, 0);

